declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = 'G-0YQ7JFNV87';

export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag('config', GA_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);
}
